



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class SeletorDeMesEAno extends Vue {
	@Prop({ type: String, default: null })
	value!: string | null

	mostrar = false

	mesFormatado: string | null = null

	@Watch('value', { immediate: true })
	onChangeValue() {
		if (!this.value) {
			this.mesFormatado = null
			return
		}
		const [ano, mes] = this.value.split('-')
		this.mesFormatado = `${mes}/${ano}`
	}

	onInput(value: string) {
		this.$emit('input', value)
		this.mostrar = false
	}
}
